import { render, staticRenderFns } from "./LiveChannel.vue?vue&type=template&id=7a40860a&scoped=true&"
import script from "./LiveChannel.vue?vue&type=script&lang=js&"
export * from "./LiveChannel.vue?vue&type=script&lang=js&"
import style0 from "./LiveChannel.vue?vue&type=style&index=0&id=7a40860a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a40860a",
  null
  
)

export default component.exports